import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

// https://nhn.github.io/tui.editor/latest/ToastUIEditorViewer
// https://github.com/nhn/tui.editor/blob/master/docs/en/viewer.md
import { Viewer } from '@toast-ui/vue-editor';
import { watch } from 'vue';

interface SRichTextViewerProps {
  content?: string;
  height?: string;
  overflow?: 'hidden' | 'scroll' | 'auto';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SRichTextViewer',
  props: {
  content: { default: '' },
  height: { default: 'auto' },
  overflow: { default: 'auto' }
},
  setup(__props) {

const props = __props;


const viewer = _ref<Viewer>();

watch(() => props.content, () => {
  viewer.value?.invoke('setMarkdown', props.content);
});

return { __sfc: true,props, viewer, _ref, Viewer, watch }
}

})